import React, { useEffect, useState, useCallback } from 'react';
import { Modal } from 'antd';
import ReactDOM from 'react-dom';
import EmailMasterTemplate from './EmailMasterTemplate';
import CreateComplexEmailTemplate from './CreateComplexMailTemplate';
import { withTranslation } from 'react-i18next';
import { MAIL_TEMPLATE_MODAL } from './translationValues';
import ComplexDocumentHistoryProvider from '../../context/complexDocumentContext';
import ComplexArtboardProvider from '../../context/complexArtboardContext';
import ComplexTextEditingProvider from '../../context/complexTextEditingContext';
import BusinessLogicProvider from '../../context/businessLogicContext';
import FontsProvider from '../../context/fontsContext';

const CreateComplexMailTemplateModal = props => {
  const { visible, onCancel, onSucess, type, template = {}, t, modal = true, selectDesign = true } = props;

  const [defaultTemplate, setDefaultTemplates] = useState(false);
  const [masterTemplate, setMasterTemplate] = useState({});

  const toggleMasterView = useCallback(() => {
    setDefaultTemplates(previousValue => {
      return !previousValue;
    });
  }, []);

  useEffect(() => {
    if (!visible) {
      setDefaultTemplates(false);
      setMasterTemplate({});
    }
  }, [visible]);

  const renderContents = () => {
    return (
      <>
        <CreateComplexEmailTemplate
          mailModal={true}
          type={type}
          onSucess={onSucess}
          template={template}
          selectDesign={selectDesign}
          setDefaultTemplates={toggleMasterView}
          defaultTemplate={defaultTemplate}
          masterTemplate={masterTemplate}
        />
        {
          defaultTemplate &&
          (modal ?
            (<div style={{ position: "absolute", top: 0, left: '100%', background: "rgb(37,41 ,45)", width: "268px", height: "100%", borderRadius: '4px 4px 8px 8px' }}>
              <EmailMasterTemplate setMasterTemplate={setMasterTemplate} />
            </div>)
            : document.getElementById('master-template-modal-body') ? ReactDOM.createPortal(
              (<div style={{ position: "absolute", background: "rgb(37,41 ,45)", width: "268px", height: "100%", borderRadius: '4px 4px 8px 8px' }}>
                <EmailMasterTemplate setMasterTemplate={setMasterTemplate} />
              </div>),
              document.getElementById('master-template-modal-body')
            ) : <div />)
        }
      </>
    )
  };

  return (

    <ComplexDocumentHistoryProvider >
      <ComplexArtboardProvider>
        <BusinessLogicProvider>
          <ComplexTextEditingProvider>
            <FontsProvider>           
              {modal ? (<Modal
                centered
                title={`${type === 'cloneTemplate' ? t(MAIL_TEMPLATE_MODAL.CLONE_TEMPLATE_TITLE.key, MAIL_TEMPLATE_MODAL.CLONE_TEMPLATE_TITLE.value) : t(MAIL_TEMPLATE_MODAL.CREATE_NEW_EMAIL_TEMPLATE_TITLE.key, MAIL_TEMPLATE_MODAL.CREATE_NEW_EMAIL_TEMPLATE_TITLE.value)}`}
                maskClosable={false}
                visible={visible}
                width="625px"
                footer={false}
                onCancel={onCancel}
                className="warning-modal"
              >
                {renderContents()}
              </Modal>
              ) : renderContents()}
            </FontsProvider>
          </ComplexTextEditingProvider>
        </BusinessLogicProvider>
      </ComplexArtboardProvider>
    </ComplexDocumentHistoryProvider>
  );
};

export default withTranslation(["MAIL_TEMPLATE_MODAL"])(CreateComplexMailTemplateModal);
